import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useRef } from 'react';
import { MdHelp } from 'react-icons/md';
import { MenuItem } from 'primereact/menuitem';
import { cn } from '../ui/cn';

const ElevatedHelpButton = ({ className = '' }) => {
	const menuTop = useRef<Menu>(null);
	const items: MenuItem[] = [{ label: 'Help Center' }, { label: 'Email Us' }, { label: 'Live Chat' }];

	return (
		<>
			<Button
				className={cn(className, 'h-[56px] w-[56px] bg-accent90 rounded-[16px] shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]')}
				icon={<MdHelp size={24} className="text-primary" />}
				onClick={(e) => menuTop.current?.toggle(e)}
			/>
			<Menu
				id="help-button-overlay"
				popup
				popupAlignment="right"
				model={items}
				ref={menuTop}
				pt={{
					root: { className: '-translate-y-1 w-[200px] rounded-[4px] py-2 bg-surfaceContainer shadow-[0px_2px_6px_2px_#00000026,0px_1px_2px_0px_#0000004D]' },
					action: { className: 'px-3 py-[14px] h-14 bg-transparent transition duration-300 hover:bg-neutralVariant95' },
					label: { className: 'font-poppins text-body-large text-onSurface' },
				}}
			/>
		</>
	);
};

export default ElevatedHelpButton;
